import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight'
import { Button } from 'antd'
import { IEvaluationResume } from 'models/evaluation.model'
import SimpleResume from '../../components/evaluation-resume'
import { Buttons } from '../../components/evaluation-resume/styled'

interface IProps {
  evaluation: IEvaluationResume
  showEvaluation: () => void
}

const InProgress = ({ evaluation, showEvaluation }: IProps) => {
  const { t } = useTranslation()
  const translationPrefix = 'lessons.contentBlocks.evaluationBlock.detail'

  return (
    <>
      <SimpleResume evaluation={evaluation} />
      <Buttons>
        <Button onClick={showEvaluation}>
          {t(`${translationPrefix}.buttons.continue`)}
          <FontAwesomeIcon icon={faArrowRight} />
        </Button>
      </Buttons>
    </>
  )
}

export default InProgress
